var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cp-social-link",class:_vm.linkClass,attrs:{"target":(_vm.openExtern) ? '_blank' : '_self',"rel":_vm.noopener}})}
var staticRenderFns = []

export { render, staticRenderFns }